<template>
  <div class="list-container">
    <div class="top-fix-area" ref="topFixArea">
      <h1 class="page-title">顧客担当者マスタ情報一覧</h1>
      <div class="mb-2">
      <router-link
        v-if="userRole == 0 || userRole == 999"
        :to="{ path: '/create-customer-representative', query: getSearchQuery() }"
        class="btn btn-sm btn-primary me-2"
      >
        顧客担当者マスタ情報作成
      </router-link> <!-- 顧客担当者マスタ情報作成ページへのリンク -->

        <!-- Button trigger modal -->
        <button v-if="userRole == 999" type="button" class="btn btn-sm btn-primary me-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
          CSVインポート
        </button>
  
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-sm btn-primary me-2" @click="downloadCsv">CSVエクスポート</button>

        <button class="btn btn-sm btn-outline-secondary" @click="isSearchExpanded = !isSearchExpanded">
        {{ isSearchExpanded ? '検索条件を非表示' : '検索条件を表示' }}
      </button>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">CSVインポート</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="clearErrorMessages"></button>
            </div>
            <div class="modal-body">
              <div v-if="errorMessages" >
                <div class="error-massage-item" v-for="errorMessage in errorMessages" :key="errorMessage.id">
                  <p class="alert alert-danger mt-2">{{ errorMessage.row_num }}行目：{{errorMessage.messages[0]}}</p>
                </div>
              </div>

              <div class="my-3">
                <p>顧客担当者情報CSVファイル選択</p>
                <input type="file" class="form-control" @change="handleFileChange">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearErrorMessages">閉じる</button>
              <button type="button" class="btn btn-primary" @click="submitFile">インポート</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 検索バーの追加 -->
      <SearchPanelWrapper :key="route.fullPath" v-model="isSearchExpanded" :getTableElement="() => tableWrapper?.$el || tableWrapper?.value" >
        <form class="search-container" style="background-color: #f8f9fa;" @submit.prevent="searchCustomerRepresentatives"> <!-- 背景色を薄く設定 -->
          <div class="d-flex flex-wrap align-items-center">

            <div class="d-flex align-items-center me-3">
              <div class="col-auto">
                <label for="searchCustomerName" class="col-form-label me-2">顧客名</label>
              </div>
              <div class="customer-search-box col-auto">
                <CustomerSelectBox
                  v-model="searchCustomerName"
                  :options="customers"
                  placeholder="顧客名で検索"
                  :formatter="c => c.customer_nm"
                />
              </div>
            </div>

            <div class="d-flex align-items-center me-3">
              <div class="col-auto">
                <label for="searchCustomerRepresentativeLastNm" class="col-form-label me-2">担当者名(姓)</label>
              </div>
              <div class="col-auto">
                <input type="text" id="searchCustomerRepresentativeLastNm" class="form-control" v-model="searchCustomerRepresentativeLastNm" placeholder="担当者名(姓)で検索">
              </div>
            </div>

            <div class="d-flex align-items-center me-3">
              <div class="col-auto">
                <label for="searchCustomerRepresentativeLastNm" class="col-form-label me-2">担当者名(名)</label>
              </div>
              <div class="col-auto">
                <input type="text" id="searchCustomerRepresentativeLastNm" class="form-control" v-model="searchCustomerRepresentativeFirstNm" placeholder="担当者名(名)で検索">
              </div>
            </div>

            <DeletedStatusSelect v-model="searchDeletedStatus" id="customerRepresentativeDeletedStatus" />

            <div class="col-auto">
              <button type="submit" class="btn btn-primary mx-1">検索</button>
              <button type="button" class="btn btn-secondary mx-1" @click="searchResetCustomerRepresentatives">クリア</button>
            </div>
          </div>
        </form>
      </SearchPanelWrapper>
    </div>

    <div class="d-flex justify-content-end" ref="paginationContainer">
      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        @change-page="handleChangePage"
      />
    </div>

    <div class="table-wrapper" ref="tableWrapper">
      <table class="master-table table table-bordered">
        <thead class="table-dark">
          <tr>
            <th class="text-nowrap">ID</th>
            <th class="text-nowrap">顧客名</th>
            <th class="text-nowrap">担当者部署</th>
            <th class="text-nowrap">担当者(姓)</th>
            <th class="text-nowrap">担当者(名)</th>
            <th class="text-nowrap">担当者メールアドレス</th>
            <th class="text-nowrap">予定表送付先宛名で使用</th>
            <th class="text-nowrap">請求書送付先宛名で使用</th>
            <th class="btn-cell"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="customer_representative in customer_representatives"
            :key="customer_representative.id"
            :class="{ 'no-active-customer-representative': customer_representative.del_flg == 1 }"
          >
            <td class="text-nowrap align-middle">{{ customer_representative.id }}</td>
            <td class="text-nowrap align-middle">{{ customer_representative.m_customer.customer_nm }}</td>
            <td class="text-nowrap align-middle">{{ customer_representative.in_charge_department_nm }}</td>
            <td class="text-nowrap align-middle">{{ customer_representative.in_charge_last_nm }}</td>
            <td class="text-nowrap align-middle">{{ customer_representative.in_charge_first_nm }}</td>
            <td class="text-nowrap align-middle">{{ customer_representative.in_charge_email }}</td>
            <td class="text-nowrap align-middle text-center"><span v-if="customer_representative.cal_destination_address_use_flg">◯</span></td>
            <td class="text-nowrap align-middle text-center"><span v-if="customer_representative.bill_destination_address_use_flg">◯</span></td>
            <td class="master-btn-cell text-nowrap align-middle">
              <router-link :to="{ name: 'CustomerRepresentativeDetail', params: { id: customer_representative.id }, query: getSearchQuery() }"> <!-- 顧客担当者情報詳細ページへのリンク -->
                <button type="button" class="btn btn-sm btn-info me-2">詳細</button>
              </router-link>

              <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'CustomerRepresentativeEdit', params: { id: customer_representative.id }, query: getSearchQuery() }"> <!-- 顧客担当者情報編集ページへのリンク -->
                <button type="button" class="btn btn-sm btn-success me-2">編集</button>
              </router-link>

              <button v-if="customer_representative.del_flg == 0 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="handleDeleteClick(customer_representative.id)">削除</button>
              <button v-if="customer_representative.del_flg == 1 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-warning" data-bs-toggle="modal" data-bs-target="#restoreModal" @click="handleRestoreClick(customer_representative.id)">復元</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 削除確認モーダル -->
    <DeleteConfirmationModal
      :paramsId="paramsIdToDelete"
      @confirmDelete="handleConfirmDelete"
    />

    <!-- 復元確認モーダル -->
    <RestoreConfirmationModal
      :paramsId="paramsIdToRestore"
      @confirmRestore="handleConfirmRestore"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import {
  getCustomerRepresentatives,
  getSelectBoxCustomers,
  deleteCustomerRepresentative,
  restoreCustomerRepresentative,
  exportCustomerRepresentativesCsv,
  importCustomerRepresentativesCsv
} from '@/api/axios';
import { Modal } from 'bootstrap';
import CustomerSelectBox from '@/components/searchSelectBoxes/CustomerSelectBox.vue'
import SearchPanelWrapper from '@/components/searchPanels/SearchPanelWrapper.vue';
import DeleteConfirmationModal from '@/components/shared/DeleteConfirmationModal.vue';
import RestoreConfirmationModal from '@/components/shared/RestoreConfirmationModal.vue';
import Pagination from '@/components/shared/Pagination.vue';
import DeletedStatusSelect from '@/components/shared/DeletedStatusSelect.vue';

export default {
  components: {
    CustomerSelectBox,
    SearchPanelWrapper,
    DeleteConfirmationModal,
    RestoreConfirmationModal,
    Pagination,
    DeletedStatusSelect
  },
  setup() {
    const title = ref('顧客担当者情報一覧');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const customers = ref([]);
    const customer_representatives = ref([]);
    const selectedFile = ref(null);

     // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    // 削除モーダルへ渡すID
    const paramsIdToDelete = ref(null);
    const paramsIdToRestore = ref(null);

    // 検索用のデータプロパティ
    const searchCustomerName = ref('');
    const searchCustomerRepresentativeLastNm = ref('');
    const searchCustomerRepresentativeFirstNm = ref('');
    const searchDeletedStatus = ref('active');

    // テーブルの高さの動的な設定
    const topFixArea = ref(null);
    const tableWrapper = ref(null);
    const paginationContainer = ref(null);

    // 検索パネルの展開状態を管理するためのリアクティブプロパティ
    const isSearchExpanded = ref(true);

    // ▼▼ 共通：検索条件をそのまま query として返す ▼▼
    const getSearchQuery = () => ({
      customer_rep_customer_id: searchCustomerName.value,
      customer_rep_last_name: searchCustomerRepresentativeLastNm.value,
      customer_rep_first_name: searchCustomerRepresentativeFirstNm.value,
      customer_rep_deleted_status: searchDeletedStatus.value,
      customer_rep_page: currentPage.value || 1
    });

    // ページネーション
    const currentPage = ref(1);
    const totalPages = ref(20); // トータルページ数を管理するためのプロパティ

    const fetchCustomerRepresentatives = async (page = 1) => {
      try {
        const response = await getCustomerRepresentatives({
          customer_id: searchCustomerName.value,
          in_charge_last_nm: searchCustomerRepresentativeLastNm.value,
          in_charge_first_nm: searchCustomerRepresentativeFirstNm.value,
          deleted_status: searchDeletedStatus.value,
          page: page
        });
        customer_representatives.value = response.data.customer_representatives;
        totalPages.value = response.data.meta.total_pages;
        currentPage.value = response.data.meta.current_page;
      } catch (error) {
        console.error('顧客担当者情報ーデータの取得に失敗しました:', error);
      }

      // 顧客情報（検索用）
      try {
        const response = await getSelectBoxCustomers();
        customers.value = response.data;
      } catch (error) {
        console.error('顧客情報ーデータの取得に失敗しました:', error);
      }
    };

    const handleChangePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        fetchCustomerRepresentatives(page);

        const q = getSearchQuery();
        q.customer_rep_page = page;

        router.replace({
          path: '/customer-representatives',
          query: q
        });

        // スクロールを tableWrapper のトップへ
        if (tableWrapper.value) {
          tableWrapper.value.scrollTop = 0;
        }
      }
    };

    const handleDeleteClick = (customer_representativeId) => {
      paramsIdToDelete.value = customer_representativeId;
    };

    const handleRestoreClick = (customer_representativeId) => {
      paramsIdToRestore.value = customer_representativeId;
    };
    
    const handleConfirmDelete = async (customer_representativeId) => {
      try {
        await deleteCustomerRepresentative(customer_representativeId);
        store.dispatch('setFlashMessage', { message: '顧客担当者情報が削除されました', type: 'success' });
        await fetchCustomerRepresentatives(currentPage.value);
      } catch (error) {
        // エラー処理
        store.dispatch('setFlashMessage', { message: '顧客担当者情報削除に失敗しました', type: 'danger' });
      }
    };

    const handleConfirmRestore = async (customer_representativeId) => {
      try {
        await restoreCustomerRepresentative(customer_representativeId);
        store.dispatch('setFlashMessage', { message: '顧客担当者情報が復元されました', type: 'success' });
        await fetchCustomerRepresentatives(currentPage.value);
      } catch (error) {
        store.dispatch('setFlashMessage', { message: '顧客担当者情報復元に失敗しました', type: 'danger' });
      }
    };

    // CSVエクスポート
    const downloadCsv = async () => {
      try {
        const response = await exportCustomerRepresentativesCsv({
          customer_id: searchCustomerName.value,
          in_charge_last_nm: searchCustomerRepresentativeLastNm.value,
          in_charge_first_nm: searchCustomerRepresentativeFirstNm.value,
          deleted_status: searchDeletedStatus.value
        });

        // 現在の年月日時分秒を取得してフォーマット
        const now = new Date();
        const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${now.getHours().toString().padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}${now.getSeconds().toString().padStart(2, "0")}`;

        const fileName = `m_customer_representatives_${timestamp}.csv`; // 動的なファイル名

        // CSVファイルをダウンロード
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("CSVダウンロードエラー", error);
      }
    };

    // CSVインポート
    const handleFileChange = (event) => {
      selectedFile.value = event.target.files[0]; // 選択されたファイルを保存
    };

    // モーダルを閉じる処理
    const closeModal = () => {
      const modalElement = document.getElementById('exampleModal');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    // モーダルが閉じた後に実行される処理
    const onModalHidden = () => {
      clearErrorMessages(); // エラーメッセージをクリアする関数を呼び出す
    };

    // モーダルの閉じるボタンのアクション
    const clearErrorMessages = () => {
      errorMessages.value = {}; // エラーメッセージをクリア
      selectedFile.value = null; // ファイルをクリア

      // inputタグのvalueをリセット
      const input = document.querySelector('.form-control[type="file"]');
      if (input) {
        input.value = '';
      }
    };

    const submitFile = async () => {
      if (!selectedFile.value) {
        store.dispatch('setFlashMessage', { message: 'ファイルが選択されていません', type: 'danger' });
        return;
      }

      try {
        await importCustomerRepresentativesCsv(selectedFile.value); // 選択されたファイルを関数に渡す
        store.dispatch('setFlashMessage', { message: 'アップロードに成功しました', type: 'success' });
        // モーダルを閉じる
        closeModal();

        // モーダルが完全に閉じた後に実行されるイベントリスナーを追加
        document.getElementById('exampleModal').addEventListener('hidden.bs.modal', onModalHidden);

        // 顧客情報の再取得
        await fetchCustomerRepresentatives();
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        console.error('アップロードに失敗しました', error);
        store.dispatch('setFlashMessage', { message: 'アップロードに失敗しました', type: 'danger' });
      }
    };

    // 顧客担当者を検索するメソッド
    const searchCustomerRepresentatives = async () => {
      await fetchCustomerRepresentatives(1);

      const q = getSearchQuery();
      q.customer_rep_page = 1;

      router.push({
        path: '/customer-representatives',
        query: q
      });
    };

    // 顧客担当者を検索リセットするメソッド
    const searchResetCustomerRepresentatives = async () => {
      searchCustomerName.value = '';
      searchCustomerRepresentativeLastNm.value = '';
      searchCustomerRepresentativeFirstNm.value = '';
      searchDeletedStatus.value = 'active';

      await fetchCustomerRepresentatives(1);

      const q = getSearchQuery();
      q.customer_rep_page = 1;

      router.replace({
        path: '/customer-representatives',
        query: q
      });
    };

    // ▼▼▼ クエリパラメータから検索条件を復元 ▼▼▼
    onMounted(() => {
      const q = route.query;

      searchCustomerName.value = q.customer_rep_customer_id || '';
      searchCustomerRepresentativeLastNm.value = q.customer_rep_last_name || '';
      searchCustomerRepresentativeFirstNm.value = q.customer_rep_first_name || '';
      searchDeletedStatus.value = q.customer_rep_deleted_status || 'active';
      currentPage.value = q.customer_rep_page ? Number(q.customer_rep_page) : 1;

      fetchCustomerRepresentatives(currentPage.value);
    });

    return {
      title,
      route,
      userRole,
      customers,
      customer_representatives,
      paramsIdToDelete,
      paramsIdToRestore,
      handleDeleteClick,
      handleConfirmDelete,
      handleRestoreClick,
      handleConfirmRestore,
      downloadCsv,
      selectedFile,
      handleFileChange,
      submitFile,
      errorMessages,
      clearErrorMessages,
      searchCustomerName,
      searchCustomerRepresentativeLastNm,
      searchCustomerRepresentativeFirstNm,
      searchDeletedStatus,
      getSearchQuery,
      currentPage,
      totalPages,
      handleChangePage,
      searchCustomerRepresentatives,
      searchResetCustomerRepresentatives,
      isSearchExpanded,
      topFixArea,
      tableWrapper,
      paginationContainer
    };
  }
};
</script>

<style scoped>
.customer-search-box .relative{
  min-width: 500px;
  max-width: 500px;
}

.no-active-customer-representative td {
  background-color: #aaa;
}
</style>
